import { useGallery } from '#@itinerary/gallery/use-gallery.js';
import { cn } from '#lib/helpers/class.js';
import { Icon } from '@iconify-icon/react';
import toast from 'react-hot-toast';

export function GalleryDiff(props) {
    const { incomingGallery, currentGallery, updatedGallery, onEdit, dayId, planId, roomId } = props;
    const filteredGallery = incomingGallery.filter((image) => !currentGallery.some((img) => img.id === image.id));

    const { onAddImage, onDelete } = useGallery({
        initialData: updatedGallery,
        onAddImage: (state) => {
            onEdit([dayId, planId, roomId], 'gallery', state);
            toast.success('Image successfully added!');
        },
        onDelete: (state) => {
            onEdit([dayId, planId, roomId], 'gallery', state);
            toast.success('Image successfully removed!');
        },
        onUpload: (state) => {
            onEdit([dayId, planId, roomId], 'gallery', state);
        }
    });

    if (!filteredGallery.length) return null;

    return (
        <div>
            <p className="pt-4 pb-2 w-full font-semibold text-left">{_t.edit.updateItinerary.gallery()}</p>
            <p className="pb-2 w-full text-sm text-left text-neutral-500">
                {_t.edit.updateItinerary.galleryDescription()}
            </p>
            <div className="grid grid-cols-2 lg:grid-cols-3 xl-grid-cols-4 gap-3 w-full">
                {filteredGallery.map((img) => {
                    const isUpdated = updatedGallery.some((image) => image.id === img.id);
                    return (
                        <figure
                            key={img.id}
                            className={cn(
                                'relative rounded overflow-hidden col-span-1 h-36 border border-neutral-500',
                                isUpdated && 'border-4 border-primary-500'
                            )}
                        >
                            <span className="absolute bottom-0 left-0 w-full p-1 bg-white bg-opacity-75 text-sm font-semibold">
                                {img?.name || `Image ${img?.id}`}
                            </span>
                            <img src={img.src} alt={img?.name} className="object-cover w-full h-full" />
                            <div
                                className={cn(
                                    'absolute left-0 top-0 w-full h-full flex justify-center items-center bg-white bg-opacity-75 opacity-0 transition-all hover:opacity-100 cursor-pointer',
                                    isUpdated
                                        ? 'text-red-500 hover:text-red-500'
                                        : 'text-primary-500 hover:text-primary-500'
                                )}
                                onClick={(e) => {
                                    isUpdated ? onDelete(img.id) : onAddImage(null, [img]);
                                }}
                            >
                                <Icon
                                    icon={isUpdated ? 'fa6-solid:xmark' : 'el:ok'}
                                    width="1.8rem"
                                    height="1.8rem"
                                    className="px-2"
                                />
                            </div>
                        </figure>
                    );
                })}
            </div>
        </div>
    );
}
